import { render, staticRenderFns } from "./BetgameEditBetmode.vue?vue&type=template&id=3df24d4d&scoped=true"
import script from "./BetgameEditBetmode.vue?vue&type=script&lang=js"
export * from "./BetgameEditBetmode.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditBetmode.vue?vue&type=style&index=0&id=3df24d4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df24d4d",
  null
  
)

export default component.exports